import React from "react";
import PropTypes from "prop-types";
import {Link} from "react-router-dom";
import {generateJobIconUrl} from "../../../services/ApiService";
import{removeHTMLtags} from "../../../services/VariableTools";
import Regions from "../../position/Description/Regions";
import '../../css/PositionList.scss';

export default class PositionListItem extends React.PureComponent{

    static propTypes = {
        customerLogoStyle: PropTypes.object,
        customerName: PropTypes.string,
        position: PropTypes.object,
        language: PropTypes.string,
        agency: PropTypes.string
    };

    static defaultProps = {
        agency: null
    };

    maxLength = 90;

    constructor(props) {
        super(props);
        this.state = {loading: false};
    }

    render() {
        let salary = removeHTMLtags(this.props.position.salary);
        if (salary.length + 3 > this.maxLength) {
            salary = salary.substring(0, this.maxLength + 1)+"...";
        }
        return (
            <div className={"col-12 col-lg-6"}>
                <Link
                    to={`/${this.props.language}/gate/${this.props.customerName}/` + (this.props.agency ? (`agency/${this.props.agency}/add-candidate/${this.props.position.id}`):(`position/${this.props.position.id}`))}>
                    <div className="job-list half-grid">
                        <div className="thumb d-none d-sm-none d-md-block" style={this.props.customerLogoStyle}>
                            <img
                                src={generateJobIconUrl(this.props.position.jobIcon, this.props.position.jobIconUpload)}
								className="img-fluid"
								onError={(e)=>{e.target.onerror = null; e.target.src="/gate/images/job/read-more.svg"}}/>
                        </div>
                        <div className="body">
                            <div className="content">
                                <h4>{removeHTMLtags(this.props.position.title)}</h4>
                                <div className="info">
                                    {this.props.position.region &&
                                    <div className="company">
                                        <Regions regions={this.props.position.region}
                                                 className="fa fa-map-marker-alt margin-right-10"
                                                 length={this.maxLength}
                                        />
                                    </div>
                                    }
                                    {salary &&
                                    <div className="office-location">
                                    <span>
                                        <i className="fa fa-money-bill-alt margin-right-10"/>
                                        {salary}
                                    </span>
                                    </div>}
                                </div>
                            </div>
                        </div>
                    </div>
                </Link>
            </div>
        );
    }
}
